import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { OfferSection } from '../components/sections/OfferSection';
import { WhoSection } from '../components/sections/WhoSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { ProofSection } from '../components/sections/ProofSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FAQSection } from '../components/sections/FAQSection';
import { CheckoutSection } from '../components/sections/CheckoutSection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  // Initialize Meta Pixel
  useMetaPixel();
  return <div className="min-h-screen flex flex-col font-body" data-id="element-219">
      <Header data-id="element-220" />

      <main className="flex-grow" data-id="element-221">
        <HeroSection data-id="element-222" />
        <ProblemSection data-id="element-223" />
        <MechanismSection data-id="element-224" />
        <OfferSection data-id="element-225" />
        <WhoSection data-id="element-226" />
        <HowItWorksSection data-id="element-227" />
        <ProofSection data-id="element-228" />
        <TestimonialsSection data-id="element-229" />
        <FAQSection data-id="element-230" />
        <CheckoutSection data-id="element-231" />
      </main>

      <Footer data-id="element-232" />
      <PurchasePopup data-id="element-233" />
    </div>;
}